import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../Constant";
import { ROUTES } from "../../../data";
import { userActions } from "../../../redux/action";
import { Font } from "../Fonts/Font";
import "./UpsellPopup.scss";

const UpsellPopup = () => {
  const dispatch = useDispatch();
  const { visible, products } = useSelector((s) => s?.upsellPopup) || {};
  const cartToken = useSelector((s) => s?.authentication?.user?.cart_token);
  const currencyConverter = useSelector((s) => s?.currencyConverter);

  if (!visible || !products || products.length === 0) return null;

  const formatPrice = (price) => {
    const curr = currencyConverter?.currency || "USD";
    const rate = currencyConverter?.amount || 1000;
    return curr + " " + ((parseFloat(price) * rate) / 1000).toFixed(2);
  };

  const handleClose = () => {
    dispatch(userActions.hideUpsellPopup());
  };

  const handleAddToCart = (product) => {
    if (!cartToken) return;
    dispatch(
      userActions.addBundleToCart([product], cartToken)
    );
  };

  return (
    <div className="upsell-overlay" onClick={handleClose}>
      <div className="upsell-popup" onClick={(e) => e.stopPropagation()}>
        <div className="upsell-popup__header">
          <Font label="You May Also Need" size={20} weight={600} />
          <button className="upsell-popup__close" onClick={handleClose}>
            &times;
          </button>
        </div>

        <div className="upsell-popup__products">
          {products.slice(0, 4).map((product) => (
            <div key={product.id} className="upsell-popup__product">
              <Link
                to={`${ROUTES.PRODUCTSINGLE}/${product.slug}`}
                className="upsell-popup__product-link"
                onClick={handleClose}
              >
                <div className="upsell-popup__product-img">
                  <img
                    src={
                      product.images?.[0]
                        ? product.images[0].startsWith("http")
                          ? product.images[0]
                          : `${API_BASE_URL}/${product.images[0]}`
                        : ""
                    }
                    alt={product.subtitle || product.title}
                    loading="lazy"
                  />
                </div>
                <p className="upsell-popup__product-name">
                  {product.subtitle || product.title}
                </p>
                <p className="upsell-popup__product-price">
                  {formatPrice(product.price)}
                </p>
              </Link>
              <button
                className="upsell-popup__add-btn"
                onClick={() => handleAddToCart(product)}
              >
                Add to Cart
              </button>
            </div>
          ))}
        </div>

        <button className="upsell-popup__continue" onClick={handleClose}>
          Continue Shopping
        </button>
      </div>
    </div>
  );
};

export { UpsellPopup };
